// components/ConduiteBlock.jsx
import React from 'react';
import './ProjectBlock.css';

const ConduiteBlock = () => {
  const interventions = [
    "Cadrage des projets et définition des objectifs",
    "Recueil, analyse et formalisation des besoins (Business Analysis)",
    "Rédaction des spécifications fonctionnelles et techniques",
    "Pilotage de projets en cycle agile ou hybride",
    "Coordination des équipes métiers et techniques",
    "Suivi des livrables et gestion des changements",
    "Accompagnement à la mise en production"
  ];

  const results = [
    "Des solutions adaptées aux besoins métier",
    "Une meilleure maîtrise des délais et des livrables",
    "Une communication fluide entre les parties prenantes",
    "Une réduction des écarts entre besoin exprimé et solution livrée"
  ];

  return (
    <div className="project-block project-block-conduite">
      <div className="project-block-header">
        <h1 className="section-title">2-Conduite de projet</h1>
        <p className="section-subtitle">
        Conduite de projet orientée valeur.
        <br/>
          Nous accompagnons les organisations dans la conduite de leurs projets, depuis la phase de cadrage 
          jusqu'à la mise en production, avec une attention particulière portée à la création de valeur métier.
          Notre approche intègre les bonnes pratiques de gestion de projet afin de garantir des solutions 
          alignées sur les besoins réels des bénéficiaires et des parties prenantes.
        </p>
      </div>

      {/* Nos Interventions */}
      <div className="project-block-section project-block-section-interventions">
        <h2 className="project-block-section-title">Nos interventions couvrent :</h2>
        <div className="project-block-list-container">
          <ul className="project-block-list">
            {interventions.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div> 

      {/* Résultats Attendus */}
      <div className="project-block-section project-block-section-results">
        <h3 className="project-block-section-title">Résultats attendus :</h3>
        <div className="project-block-list-container">
          <ul className="project-block-list">
            {results.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ConduiteBlock;